import React, { useRef, useState } from 'react';
import { Modal } from 'rsuite';
import Viewer from '@/property-details/pdf-viewer/viewer';
import styled from 'styled-components';

export const PDFViewerModal = styled(Modal)`
  display: flex;
  justify-content: center;
  width: 785px;
  min-width: 785px;

  padding-top: 0;

  .rs-modal-content {
    padding: 0;
  }
`;

export function PDFViewer(props) {
  const [printMode, setPrintMode] = useState(false);
  const [pdfPages, setPdfPages] = useState(0);

  const printContentRef = useRef(null);

  const Header = props.headerComponent;
  const Footer = props.footerComponent;

  return (
    <PDFViewerModal
      size="md"
      backdrop={true}
      onClose={props.closePdfModal}
      open={props.showPdfModal}
    >
      {Boolean(props.headerComponent) && (
        <Header
          {...props.headerProps}
          numPages={pdfPages}
          printContentRef={printContentRef}
          onBeforePrint={() => setPrintMode(true)}
          onAfterPrint={() => setPrintMode(false)}
        />
      )}

      <Viewer
        numPages={pdfPages}
        pdfFilePath={props.pdfFilePath}
        printContentRef={printContentRef}
        printMode={printMode}
        onDocumentLoadSuccess={({ numPages }) => {
          setPdfPages(numPages);
        }}
        currentPage={props.currentPage}
      />

      {Boolean(props.footerComponent) && <Footer {...props.footerProps} />}
    </PDFViewerModal>
  );
}
